import Vue from 'vue';
import Vuex from 'vuex';
import form from './modules/form';
import user from './modules/user';
import config from './modules/config';
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
  modules: {
    form: form,
    user: user,
    config: config
  },
  strict: debug
});

global.store = store;
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js